import React from "react"
import { graphql } from "gatsby"
import Helmet from 'react-helmet'
import Img from "gatsby-image"
import AniLink from "gatsby-plugin-transition-link/AniLink"

import Hero from "../components/sections/hero/hero"

import Layout from "../components/theme/theme"

import "../components/sections/section/section.css"
import "../components/sections/section/bullet-list.css"

const IndexPage = props => {
  const heroImages = [
    props.data.mobileHero.childImageSharp.fluid,
    {
      ...props.data.desktopHero.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]

  return (
    <Layout>
      <Helmet title="Single point of contact throughout the process" />

      <Hero image={heroImages} textcolor="dark" subtitle="Get to know the process" title="Single point of contact for all your requirements" />

      <section className="sec-Section">
        <div className="sec-Section_Inner lyt-Container">
          <div className="sec-Section_Header">
            <div className="sec-Section_Inset">
              <h3 className="sec-Section_SubTitle">
                We make it simple
              </h3>

              <h2 className="sec-Section_Title">
                Your single point of contact
              </h2>
            </div>
          </div>

          <div className="sec-Section_Body">
            <div className="sec-Section_Inset">
              <p>CBW Limited aim to provide a single point of contact for all your requirements. We strive to provide a fully managed product, from the initial point of contact through to completion.</p>

              <p>Whether it is a small repair or a full renovation, each job is unique to us, so the process will be tailored to suit your needs where possible.</p>

              <p>To find out more, or to obtain a quote tailored to your requirements, <AniLink cover bg="#22242b" direction="up" className="sec-Section_Link" to="/contact">please contact us</AniLink> to discuss your requirements.</p>

              <Img fluid={props.data.designImage.childImageSharp.fluid} className="sec-Section_WideImage" />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    desktopHero: file(relativePath: { eq: "process-hero.jpg" }) {
      ...fluidImage
    }
    mobileHero: file(relativePath: { eq: "process-hero-mobile.jpg" }) {
      ...fluidImage
    }
    designImage: file(relativePath: { eq: "process-sub-image.jpg" }) {
      ...fluidImage
    }
  }
`;

export const fluidImage = graphql`
  fragment fluidImage on File {
    childImageSharp {
      fluid(maxWidth: 2880) {
        ...GatsbyImageSharpFluid
      }
    }
  }
`
